import {addToListModalStyles} from "@insite/content-library/Components/AddToListModal"
import { css } from "styled-components"

addToListModalStyles.addButton = {
    mergeCss: true,
    css: css`
        margin-left: 10px;
    `,
}

addToListModalStyles.scheduleReminderCheckbox={
    css:css`
      display: none;
    `
}